import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const Login = (props) => {
  const { userData, checkLogin, isAuthenticated } = props;
  useEffect(() => {
    checkLogin(); //call identityserver method to redirect
  }, [checkLogin]);

  //redirect back to the previously queried address, saved in the localStorage
  return isAuthenticated && <Redirect to={userData.currentPath || '/'} />;
};

Login.propTypes = {
  isAuthenticated: PropTypes.bool,
  userData: PropTypes.shape({
    currentPath: PropTypes.string.isRequired,
  }), //from withUserData HOC
  checkLogin: PropTypes.func.isRequired,
};

Login.defaultProps = {
  isAuthenticated: false,
};

export default Login;
